<template>
  <ScrollTopComponent>
      <a class="btn "><span class="btntext">^</span></a>
  </ScrollTopComponent>
</template>

<script>
import ScrollTopComponent from './ScrollTopComponent'
export default {
  components: {
    ScrollTopComponent
  }
}
</script>

<style>
.btn {
    width:100px;
    height:100px;
    padding-top: 27px;
    padding-left: 10px;
    padding-right: 10px;
    padding-bottom: 5px;
    opacity:.5;

    cursor:pointer;
    z-index:99;
}
.btntext{
  font-size:3em;
  z-index:99;
}
</style>
